import { GridColumns } from '@mui/x-data-grid-pro';

type Columns<Row extends Object, RowChild extends Object> = (Omit<GridColumns<Row | RowChild>[number], 'renderCell'> & {
  renderCell: GridColumns<Row>[number]['renderCell'];
  renderChildCell?: GridColumns<RowChild>[number]['renderCell'];
})[];

export function createGroupColumns<Row extends Object, RowChild extends Object>(
  rowIdentifier: keyof Row,
  columns: Columns<Row, RowChild>
): GridColumns<Row | RowChild> {
  return columns.map(column => {
    const gridColumn: GridColumns<Row | RowChild>[number] = {
      ...column,
      renderCell: params => {
        if (rowIdentifier in params.row) {
          return column.renderCell?.(params as any);
        }
        return column.renderChildCell?.(params as any);
      }
    };
    return gridColumn;
  });
}
